import { chainConfigs, ChainId } from 'bzx-common/src/config/appConfig'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import { providers } from 'ethers5'
import { RPCSubprovider, Web3ProviderEngine } from '@0x/subproviders'
import { Web3Wrapper } from '@0x/web3-wrapper'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { ConnectorUpdate } from '@web3-react/types'

export default class Web3ConnectionFactory {
  public static rpcSubprovider: RPCSubprovider
  public static networkId: number
  public static canWrite: boolean
  public static userAccount: string | undefined
  public static providerEngine: any
  public static web3Wrapper: Web3Wrapper
  public static currentConnector: AbstractConnector | undefined
  static etherProvider: providers.JsonRpcProvider

  public static async setWalletProvider(
    connector: AbstractConnector,
    providerType: ProviderType,
    web3ReactAccount?: string
  ) {
    try {
      const provider = await connector.getProvider()
      const account = await connector.getAccount()
      const chainId = (await connector.getChainId()).toString()
      const networkId = chainId.includes('0x') ? parseInt(chainId, 16) : parseInt(chainId, 10)
      const web3Wrapper = new Web3Wrapper(provider)

      const canWrite = true
      Web3ConnectionFactory.userAccount = account
        ? account
        : web3ReactAccount
        ? web3ReactAccount
        : undefined

      Web3ConnectionFactory.providerEngine = provider
      Web3ConnectionFactory.networkId = networkId
        ? networkId
        : await web3Wrapper.getNetworkIdAsync()
      Web3ConnectionFactory.web3Wrapper = web3Wrapper
      Web3ConnectionFactory.canWrite = canWrite
      Web3ConnectionFactory.etherProvider = new providers.JsonRpcProvider(
        chainConfigs[networkId as ChainId].rpcUrlDefault
      )
    } catch (e) {
      console.error(e)
      const chainId = (localStorage.getItem('userChainId') || 1) as ChainId
      return Web3ConnectionFactory.setReadonlyProvider(chainId)
    }
  }

  public static getRPCSubprovider(chainId: ChainId): RPCSubprovider {
    return new RPCSubprovider(chainConfigs[chainId].rpcUrlDefault)
  }

  public static getEthersProvider(chainId: ChainId): providers.BaseProvider {
    return new providers.JsonRpcProvider(chainConfigs[chainId].rpcUrlDefault)
  }

  public static async setReadonlyProvider(chainId: ChainId) {
    const providerEngine: Web3ProviderEngine = new Web3ProviderEngine({ pollingInterval: 3600000 }) // 1 hour polling
    providerEngine.addProvider(this.getRPCSubprovider(chainId))

    return new Promise((resolve) => {
      providerEngine.start(async () => {
        Web3ConnectionFactory.providerEngine = providerEngine
        Web3ConnectionFactory.web3Wrapper = new Web3Wrapper(providerEngine)
        Web3ConnectionFactory.networkId =
          await Web3ConnectionFactory.web3Wrapper.getNetworkIdAsync()
        Web3ConnectionFactory.canWrite = false
        Web3ConnectionFactory.userAccount = undefined
        Web3ConnectionFactory.etherProvider = new providers.JsonRpcProvider(
          chainConfigs[Web3ConnectionFactory.networkId as ChainId].rpcUrlDefault
        )
        resolve(true)
      })
    })
  }

  public static updateConnector(update: ConnectorUpdate) {
    const { chainId, account } = update
    if (chainId) {
      const networkId = chainId.toString()
      Web3ConnectionFactory.networkId = networkId.includes('0x')
        ? parseInt(networkId, 16)
        : parseInt(networkId, 10)
    }
    if (account) {
      Web3ConnectionFactory.userAccount = account
    }
  }
}
